(function () {
  if (typeof NodeList.prototype.forEach === "function") return false;
  NodeList.prototype.forEach = Array.prototype.forEach;
})();


//////////////////
// WEBPACK FOOTER
// ./config/polyfills/forEach.js
// module id = 211
// module chunks = 0